import { render, staticRenderFns } from "./zimlet-tree.vue?vue&type=template&id=4a076e4a"
import script from "./zimlet-tree.vue?vue&type=script&lang=js"
export * from "./zimlet-tree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports